/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { GetInteractionQueryResponse, GetInteractionPathParams, GetInteractionHeaderParams, GetInteraction401, GetInteraction404 } from "../../models/interactionsController/GetInteraction";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getInteractionQueryKey = (interactionId: GetInteractionPathParams["interactionId"]) => [{ url: '/interactions/:interactionId', params: {interactionId:interactionId} }] as const

export type GetInteractionQueryKey = ReturnType<typeof getInteractionQueryKey>

/**
 * @description Returns when the interaction occurred, its direction, and channel details. Scoped to the tenant from request context.
 * @summary Get interaction by id
 * {@link /interactions/:interactionId}
 */
export async function getInteraction(interactionId: GetInteractionPathParams["interactionId"], headers?: GetInteractionHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetInteractionQueryResponse, ResponseErrorConfig<GetInteraction401 | GetInteraction404>, unknown>({ method : "GET", url : `/interactions/${interactionId}`, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getInteractionQueryOptions(interactionId: GetInteractionPathParams["interactionId"], headers?: GetInteractionHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getInteractionQueryKey(interactionId)
        return queryOptions<GetInteractionQueryResponse, ResponseErrorConfig<GetInteraction401 | GetInteraction404>, GetInteractionQueryResponse, typeof queryKey>({
         enabled: !!(interactionId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getInteraction(interactionId, headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns when the interaction occurred, its direction, and channel details. Scoped to the tenant from request context.
 * @summary Get interaction by id
 * {@link /interactions/:interactionId}
 */
export function useGetInteraction<TData = GetInteractionQueryResponse, TQueryData = GetInteractionQueryResponse, TQueryKey extends QueryKey = GetInteractionQueryKey>(interactionId: GetInteractionPathParams["interactionId"], headers?: GetInteractionHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<GetInteractionQueryResponse, ResponseErrorConfig<GetInteraction401 | GetInteraction404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getInteractionQueryKey(interactionId)
         

         const query = useQuery({
          ...getInteractionQueryOptions(interactionId, headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetInteraction401 | GetInteraction404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}